import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TaxReporting = ({ data }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
            Tax Reporting
          </h3>
          <p className="text-sm text-muted-foreground">
            Sales tax, payroll, and business expense documentation
          </p>
        </div>
        <Button variant="primary" iconName="Download" iconPosition="left">
          Generate Report
        </Button>
      </div>
      <div className="space-y-4">
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name="Receipt" size={20} color="var(--color-primary)" />
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground">Sales Tax</h4>
                <p className="text-xs text-muted-foreground">{data?.salesTax?.period}</p>
              </div>
            </div>
            <div className="text-right">
              <div className="text-lg font-semibold text-foreground data-text">
                ${data?.salesTax?.collected?.toLocaleString()}
              </div>
              <div className="text-xs text-muted-foreground">{data?.salesTax?.rate}% rate</div>
            </div>
          </div>
          <div className="flex items-center justify-between text-xs">
            <span className="text-muted-foreground">Due Date:</span>
            <span className="text-foreground font-medium">{data?.salesTax?.dueDate}</span>
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
                <Icon name="Users" size={20} color="var(--color-success)" />
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground">Payroll Tax</h4>
                <p className="text-xs text-muted-foreground">{data?.payrollTax?.period}</p>
              </div>
            </div>
            <div className="text-right">
              <div className="text-lg font-semibold text-foreground data-text">
                ${data?.payrollTax?.withheld?.toLocaleString()}
              </div>
              <div className="text-xs text-muted-foreground">Withheld</div>
            </div>
          </div>
          <div className="flex items-center justify-between text-xs">
            <span className="text-muted-foreground">Due Date:</span>
            <span className="text-foreground font-medium">{data?.payrollTax?.dueDate}</span>
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
              <Icon name="FileText" size={20} color="var(--color-accent)" />
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground">Business Expenses</h4>
              <p className="text-xs text-muted-foreground">Deductible categories</p>
            </div>
          </div>
          <div className="space-y-2">
            {data?.businessExpenses?.map((expense, idx) => (
              <div key={idx} className="flex items-center justify-between bg-card rounded-lg p-3">
                <div className="flex items-center gap-2">
                  <Icon name="CheckCircle" size={14} color="var(--color-success)" />
                  <span className="text-sm text-foreground">{expense?.category}</span>
                </div>
                <span className="text-sm font-semibold text-foreground data-text">
                  ${expense?.amount?.toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxReporting;